import React from 'react';

export default function Toggle({
    label,
    checked = false,
    onChange,
    disabled = false,
    size = 'md',
    className = '',
}) {
    const track = size === 'sm' ? 'h-4 w-7' : 'h-5 w-9';
    const thumb = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4';
    const translate = size === 'sm' ? 'translate-x-3.5' : 'translate-x-4.5';

    return (
        <label className={`inline-flex items-center gap-2 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}>
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                disabled={disabled}
                onClick={() => !disabled && onChange?.(!checked)}
                className={`relative inline-flex ${track} shrink-0 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1 ${checked ? 'bg-gray-900' : 'bg-gray-200'}`}
            >
                <span className={`inline-block ${thumb} rounded-full bg-white shadow-sm transition-transform duration-200 ${checked ? translate : 'translate-x-0.5'}`} />
            </button>
            {label && <span className="text-sm text-gray-700 select-none">{label}</span>}
        </label>
    );
}
